import { render, staticRenderFns } from "./EncounterServiceRequests.vue?vue&type=template&id=09abcf35&"
import script from "./EncounterServiceRequests.vue?vue&type=script&lang=js&"
export * from "./EncounterServiceRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports